angular.module("events")

    .controller("EventsDocumentsEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal', 'Upload',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal, Upload) {

            //Opciones del editor
            $scope.tinymceOptions = {
                resize: true,
                //forced_root_block: 'div',
                min_height: 60,
                contextmenu: false,
                branding: false,
                height: 60,
                schema: "html5",
                formats: {
                    bold: { inline: 'b' },
                    underline: { inline: 'u' },
                    italic: { inline: 'i' },
                    alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "left" } },
                    aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "center" } },
                    alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "right" } },
                    alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "justify" } },
                },
                invalid_elements: 'strong,em',
                fontsize_formats: "8px 10px 12px 14px 15px 16px 18px 20px 22px 24px 25px 28px 30px 36px ",
                font_formats: 'Arial=Arial;Cambria=Cambria;Courier New=Courier New;Segoe Script=Segoe Script;Tahoma=Tahoma;Verdana=Verdana',
                body_class: 'custom_tinymce_content',
                language: $translate.use().toLowerCase(), //Hay que customizarlo dependiendo del idioma...
                paste_as_text: true,
                plugins: 'paste textcolor',
                toolbar: "undo redo |  fontsizeselect bold underline italic | forecolor fontselect | alignleft aligncenter alignright alignjustify",
                menubar: false
            };

            if ($state.current.name == "events.edit.documents.edit") {

                Restangular.one('Events', $stateParams.id).get().then(function (results) {
                    $scope.event = results;
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('events.title'), url: "events.list" },
                        { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
                        { title: $filter('translate')('events.documents.documents'), url: "events.edit.documents({ id:" + $stateParams.id + " })" },
                        { title: $filter('translate')('events.documents.configure') }
                    ];
                });
                $scope.isDocumentEditState = true;
            } else {
                $scope.isDocumentEditState = false;
            }

            $scope.eventId = $stateParams.id;

            if ($state.current.name == "events.edit.documents.edit") {
                $scope.document_type_id = $stateParams.document_type_id;
            }
            $scope.loadOptions = function (document_type_id, show_by_default) {
                $scope.document_type_id = document_type_id;
                $scope.loadData(show_by_default);
            };
            
            $scope.documents = {
                event_id: $scope.eventId,
                document_type_id: $scope.document_type_id
            };

            $scope.loadData = function (show_by_default) {
                var options = { document_type_id: $scope.document_type_id, event_id: $stateParams.id, show_by_default: show_by_default };
                Restangular.all('DocumentsTypesVariables').getList(options).then(function (response) {
                    $scope.documents_types_variables = response;
                });
            };
            if ($state.current.name == "events.edit.documents.edit") {
                $scope.loadData();
            }
               

            $scope.save = function () {
                // if (angular.isUndefined($stateParams.document_type_id) || $stateParams.document_type_id == "") {
                //Limpiamos los caracteres raros.

                var copyDocumentsTypesVariables = angular.copy($scope.documents_types_variables);
                for (var i = 0; i < $scope.documents_types_variables.length; i++) {
                    for (var j = 0; j < $scope.documents_types_variables[i].FK_events_documents_types_document_types_variables.length; j++) {
                        if ($scope.documents_types_variables[i].FK_events_documents_types_document_types_variables[j].value == "<div>&nbsp;</div>") {
                            copyDocumentsTypesVariables[i].FK_events_documents_types_document_types_variables[j].value = "";
                            break;
                        }
                        if ($scope.documents_types_variables[i].FK_events_documents_types_document_types_variables[0].is_explicit_document_type == true) {
                            copyDocumentsTypesVariables[i].FK_events_documents_types_document_types_variables[j].is_explicit_document_type = true;
                        } else {
                            copyDocumentsTypesVariables[i].FK_events_documents_types_document_types_variables[j].is_explicit_document_type = false;
                        }
                    }
                }

                $scope.results = {
                    event_id: $scope.eventId,
                    documentTypesVariables: copyDocumentsTypesVariables
                }

                Restangular.all('DocumentsTypesVariables/CustomDocumentTypesVariables').post($scope.results).then(function (result) {

                    $scope.loadData();
                });
            }

            $scope.addFile = function (flowFile, id) {
                var fileReader = new FileReader();
                fileReader.onload = function (event) {
                    var uri = event.target.result;
                    $scope.$apply(function () {
                        angular.forEach($scope.documents_types_variables, function (item) {
                            if (item.id == id) {
                                if (item.FK_events_documents_types_document_types_variables.length == 0) {
                                    item.FK_events_documents_types_document_types_variables.push({ icon: "isNewImage", value: uri });
                                } else {
                                    item.FK_events_documents_types_document_types_variables[0].icon = "isNewImage";
                                    item.FK_events_documents_types_document_types_variables[0].value = uri;
                                }
                                item.FK_events_documents_types_document_types_variables.delete_icon = false;
                            }
                        });
                        
                    });
                };
                fileReader.readAsDataURL(flowFile.file);
            };
           

        }])
;

